import React, { useState, useEffect, useCallback } from 'react';
import Pagination from '../Pagination';
import axios from '../../api/api';
import { Link } from 'react-router-dom';
import { MdOutlineBlock, MdEdit, MdOutlineClose } from 'react-icons/md';
import { IoCheckmarkSharp } from 'react-icons/io5';
import { toast } from 'sonner'
import Loader from '../Loader';

const ListAdmins = () => {

  const [admin, setUser] = useState([]);
  const [searchUserEmail, setSearchUserEmail] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(20);
  const [count, setCount] = useState(0)
  const [total, setTotal] = useState(0)

  // Fetch All admin
  const getUser = useCallback(async (offset, limit, email) => {
    try {
      let query = `?offset=${offset}&limit=${limit}`

      if (email) {
        query += `&email=${email}`
      }

      const response = await axios.get(`/users/${query}`);
      setUser(response.data.items);
      setCount(response.data.count)
      setTotal(response.data.total)
      setLoading(false);
      setError(null);
    } catch (error) {
      console.log(error);
      setLoading(false);
      if (!error.response) {
        setError('Network error! Check your connection.');
      } else if (error.response.status >= 500) {
        setError('Server error! Please try again later.');
      } else {
        setError('An unexpected error occurred!');
      }
    }
  }, []);

  useEffect(() => {
    const timerId = setTimeout(() => {
      setLoading(true);
      getUser((currentPage - 1) * recordsPerPage, recordsPerPage, searchUserEmail);
    }, 1000);
    return () => clearTimeout(timerId);
  }, [currentPage, recordsPerPage, searchUserEmail, getUser]);


  // search admin by email
  const handleSearchChange = (e) => {
    setSearchUserEmail(e.target.value);
    setCurrentPage(1);
  };

   // enable a admin
   const enableAdmin = async (id) => {
    const confirmed = window.confirm('Are you sure you want to enable this admin');
    if (confirmed) {
      try {
        await axios.put(`/admins/${id}/enable`);
        toast.success('Admin Enabled');
        getUser((currentPage - 1) * recordsPerPage, recordsPerPage, searchUserEmail);
      } catch (error) {
        toast.error('Failed to enable admin');
        console.log(error);
      }
    }
  };
  
  // disable a admin
  const disableAdmin = async (id) => {
    const confirmed = window.confirm('Are you sure you want to disable this admin');
    if (confirmed) {
      try {
        await axios.put(`/admins/${id}/disable`);
        toast.info('Admin Disabled');
        getUser((currentPage - 1) * recordsPerPage, recordsPerPage, searchUserEmail);
      } catch (error) {
        toast.error('Failed to disable admin');
        console.log(error);
      }
    }
  };

  return (
    <div className='mx-auto p-4'>
      <div className='bg-white rounded-lg p-4 xl:w-[78vw] 2xl:w-full'>
        <div className='flex flex-wrap items-center justify-between py-3'>
          <Link to='/addadmin' className='bg-[#134463] hover:bg-[#2b1e3e] text-white px-5 py-1.5 rounded-lg'>Add Admin</Link>
          <h5 className='text-[#2b1e3e] font-bold'>Showing {count} / {total} Admins</h5>
          <div className='py-2'>
            <form>
              <label htmlFor='search'><span className='hidden'>Search</span>
                <input
                  type='search'
                  id='search'
                  className='px-3 py-1 border bg-[#eef1ff] border-slate-300 placeholder-slate-400 rounded-md focus:outline-none focus:border-[#2b1e3e] focus:ring-[#2b1e3e] focus:ring-1'
                  required
                  placeholder='Search email'
                  value={searchUserEmail}
                  onChange={handleSearchChange}
                />
              </label>
            </form>
          </div>
        </div>
        {loading ? (
          <div className='flex items-center justify-center bg-[#eef1ff] h-[70vh]'>
            <Loader />
          </div>
        ) : error ? (
          <div className='bg-[#eef1ff] grid place-items-center h-[70vh]'>
            <div className='grid place-items-center text-red-600 p-4'>
              <h3><MdOutlineBlock /></h3>
              <span>{error}</span>
            </div>
          </div>
        ) : (
          <div className='overflow-x-auto rounded-lg'>
            {admin.length > 0
              ? (
                <table className='w-full text-left table-auto'>
                  <thead>
                    <tr className='border-b border-slate-500'>
                      <th className='p-2'>No</th>
                      <th className='p-2'>First Name</th>
                      <th className='p-2'>Last Name</th>
                      <th className='p-2'>Email</th>
                      <th className='p-2'>Role</th>
                      <th className='p-2'>Status</th>
                      <th className='p-2'>Last Login</th>
                      <th className='p-2'>Created At</th>
                      <th className='p-2'>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {admin.map((admin) => (
                      <tr key={admin.id}>
                        <td className='p-2 '>{admin.id}</td>
                        <td className='p-2'>{admin.first_name}</td>
                        <td className='p-2'>{admin.last_name}</td>
                        <td className='p-2'>{admin.email}</td>
                        <td className='p-2'>{admin.role}</td>
                        <td className='p-2'>{admin.status}</td>
                        <td className='p-2'>{new Date(admin.last_login_date).toLocaleString("en-CA", { hour12: false })}</td>
                        <td className='p-2'>{new Date(admin.created_at).toLocaleString("en-CA", { hour12: false })}</td>
                        <td className='p-2 flex items-center space-x-2'>
                          <Link to={`/updateadmin/${admin.id}`}><button className='bg-green-200 text-green-700 p-1 text-xl rounded-lg'><MdEdit /></button></Link>
                          {admin.status === "ENABLED" ? (
                            <button onClick={() => disableAdmin(admin.id)} className='text-orange-600 hover:text-orange-500 flex items-center'><span><MdOutlineClose /></span>Disable</button>
                          ) : (
                            <button onClick={() => enableAdmin(admin.id)} className='text-green-600 hover:text-green-500 flex items-center'><span><IoCheckmarkSharp /></span>Enable</button>
                          )}
                        </td>                        
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className='bg-[#eef1ff] text-[#134463] grid place-items-center h-[70vh]'>
                  <div className='grid place-items-center p-4'>
                    <h3><MdOutlineBlock /></h3>
                    <h4>No Data</h4>
                  </div>
                </div>
              )}
          </div>
        )}
        <div className='flex flex-wrap items-center justify-between mt-4 gap-4'>
          <div>
            <span className='mr-2'>Records per page:</span>
            <select
              className='px-3 py-1 border bg-[#eef1ff] border-slate-300 rounded-md focus:outline-none focus:border-[#2b1e3e] focus:ring-[#2b1e3e] focus:ring-1'
              value={recordsPerPage}
              onChange={(e) => {
                setRecordsPerPage(parseInt(e.target.value, 10));
                setCurrentPage(1);
              }}
            >
              <option value='20'>20</option>
              <option value='50'>50</option>
              <option value='75'>75</option>
              <option value='100'>100</option>
            </select>
          </div>
          <Pagination
            nPages={Math.ceil(total / recordsPerPage)}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </div>
      </div>
    </div>
  );
};

export default ListAdmins;